import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Button, SelectField, Autocomplete, DialogContainer } from "react-md";
import ServiceProviderConsultation from "./ServiceProviderConsultation";
import { isValidLandline } from "../helper/validateLandline";
import ServiceProviderHealthCheckup from "./ServiceProviderHealthCheckup";
import ServiceProviderGym from "./ServiceProviderGym";
import ServiceProviderDentalCheckup from "./ServiceProviderDentalCheckup";
import "../styles/index.css";
import FontIcon from "react-md/lib/FontIcons";
import CreateServiceUtil from "../services/CreateServiceUtil";
import EventService from "../../../../../service/event/EventService";
import CreateServiceProviderUtil from "../services/CreateServiceProviderUtil";
import { useCallback } from "react";
import ServiceProviderVaccine from "./ServiceProviderVaccine";

export const CreateServiceProvider = (props) => {
  const [serviceProviderView, setServiceProviderView] = useState(0);
  const createServiceUtil = new CreateServiceUtil();
  const createServiceProviderUtil = new CreateServiceProviderUtil();
  const [mode, setMode] = useState(null);
  const [servicesTypeArr, setServicesTypeArr] = useState([]);
  const [servicesTypeObj, setServicesTypeObj] = useState([]);
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState(null);
  const [SPbodyToUpdate, setSPbodyToUpdate] = useState(null);
  const [openPropCalendarChangesDialog, setOpenPropCalendarChangesDialog] =
    useState(false);
  const [showUpdateCityMappingNowDialog, setShowUpdateCityMappingNowDialog] =
    useState(false);
  const [initialCityMapping, setInitialCityMapping] = useState({});
  const enableCityMappingTextRef = useRef(null);

  const [providerToCreate, setProviderToCreate] = useState({
    serviceTypeId: "",
    serviceSubtypeId: "",
    isActive: "",
    consultationInfo: {
      identityDetails: {},
      contactDetails: {},
      address: {},
      reviewData: {},
      vendorGroup: {},
      availability: {
        config: {
          slotDurationInMinutes: "",
          bookingPerSlot: "",
          minBookingDays: "",
          maxAdvBookingDays: "",
        },
        schedule: {
          sunday: [],
          monday: [],
          tuesday: [],
          wednesday: [],
          thursday: [],
          friday: [],
          saturday: [],
        },
        unavailableTime: [],
        availableTime: [],
      },
    },
    checkupInfo: {
      identityDetails: {},
      contactDetails: {},
      address: {},
      reviewData: {},
      vendorGroup: {},
      availability: {
        config: {
          slotDurationInMinutes: "",
          bookingPerSlot: "",
          minBookingDays: "",
          maxAdvBookingDays: "",
        },
        schedule: {
          sunday: [],
          monday: [],
          tuesday: [],
          wednesday: [],
          thursday: [],
          friday: [],
          saturday: [],
        },
        unavailableTime: [],
        availableTime: [],
      },
    },
    vaccineInfo: {
      identityDetails: {},
      contactDetails: {},
      address: {},
      reviewData: {},
      vendorGroup: {},
      availability: {
        config: {
          slotDurationInMinutes: "",
          bookingPerSlot: "",
          minBookingDays: "",
          maxAdvBookingDays: "",
        },
        schedule: {
          sunday: [],
          monday: [],
          tuesday: [],
          wednesday: [],
          thursday: [],
          friday: [],
          saturday: [],
        },
        unavailableTime: [],
        availableTime: [],
      },
    },
    dentalInfo: {
      identityDetails: {},
      contactDetails: {},
      address: {},
      reviewData: {},
      vendorGroup: {},
      availability: {
        config: {
          slotDurationInMinutes: "",
          bookingPerSlot: "",
          minBookingDays: "",
          maxAdvBookingDays: "",
        },
        schedule: {
          sunday: [],
          monday: [],
          tuesday: [],
          wednesday: [],
          thursday: [],
          friday: [],
          saturday: [],
        },
        unavailableTime: [],
        availableTime: [],
      },
    },
    gymInfo: {
      identityDetails: {},
      contactDetails: {},
      address: {},
      reviewData: {},
      vendorGroup: {},
      availability: {
        config: {
          slotDurationInMinutes: 0,
          bookingPerSlot: 0,
          minBookingDays: 0,
          maxAdvBookingDays: 0,
        },
        schedule: {
          sunday: [],
          monday: [],
          tuesday: [],
          wednesday: [],
          thursday: [],
          friday: [],
          saturday: [],
        },
        unavailableTime: [],
        availableTime: [],
      },
    },
  });
  //-----

  useEffect(() => {
    if (props.data.mode == "create") {
      setMode(1);
    } else if (props.data.mode == "view") {
      getServiceProvider();
      setMode(2);
    } else if (props.data.mode == "update") {
      setMode(3);
      getServiceProvider();
    }
    getServiceType();
  }, []);

  const updatePI = useCallback((newValue, ind) => {
    setProviderToCreate((prev) => {
      return { ...prev, ...newValue };
    });
  }, []);
  useEffect(() => {
    if (
      (props.data.mode == "view" || props.data.mode == "update") &&
      providerToCreate.serviceTypeName &&
      countries != null
    ) {
      if (
        providerToCreate.serviceTypeId == 1 &&
        providerToCreate.consultationInfo.identityDetails.name
      ) {
        setServiceProviderView(1);
      } else if (
        providerToCreate.serviceTypeId == 2 &&
        providerToCreate.checkupInfo.identityDetails.name
      ) {
        setServiceProviderView(2);
      } else if (
        providerToCreate?.serviceTypeId == 3 &&
        providerToCreate?.vaccineInfo?.identityDetails?.name
      ) {
        setServiceProviderView(3);
      } else if (
        providerToCreate?.serviceTypeId == 4 &&
        providerToCreate?.gymInfo?.identityDetails?.name
      ) {
        setServiceProviderView(4);
      } else if (
        providerToCreate?.serviceTypeId == 5 &&
        providerToCreate?.dentalInfo?.identityDetails?.name
      ) {
        setServiceProviderView(5);
      }
    }
  }, [providerToCreate, countries]);

  useEffect(() => {
    let dropdownObj = servicesTypeArr.map((e) => {
      return {
        label: e.name,
        value: e.id,
      };
    });
    setServicesTypeObj(dropdownObj);
  }, [servicesTypeArr]);

  //--------------------
  let calendarHeadings = [
    "Master weekly schedule of the provider",
    "Service provider unavailability beyond master weekly schedule",
    "Service provider availability beyond master weekly schedule",
    "availability beyond default weekly schedule",
  ];

  const scrollToCitySelectionHeading = () => {
    requestAnimationFrame(() => {
      if (enableCityMappingTextRef?.current) {
        enableCityMappingTextRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    });
  };

  const phoneNoLen = (cc) => {
    return countries?.find((c) => c.code == cc).phoneNoLen;
  };

  let getServiceType = () => {
    let onResponse = (res) => {
      setServicesTypeArr((prev) => {
        const updatedState = [...res];
        return updatedState;
      });
      getCountryCodes();
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    createServiceUtil.getServiceType(true, onResponse, onError);
  };
  let getCountryCodes = () => {
    let onResponse = (res) => {
      setCountries(res);
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    createServiceProviderUtil.getCountries(onResponse, onError);
  };
  let onExit = () => {
    setServiceProviderView(0);
    setMode(null);
    setServicesTypeArr([]);
    setServicesTypeObj([]);
    setProviderToCreate({});
    setSPbodyToUpdate(null);
    setOpenPropCalendarChangesDialog(false);
    props.setView(4);
  };

  let getServiceProvider = (serviceProviderId) => {
    let onResponse = (res) => {
      let status = res.isActive == true ? "true" : "false";
      let body = { ...res, isActive: status };
      if (
        body.serviceTypeId == 1 &&
        body.consultationInfo.contactDetails.callingNumber.countryCode == 0
      ) {
        body = {
          ...body,
          consultationInfo: {
            ...body.consultationInfo,
            contactDetails: {
              ...body.consultationInfo.contactDetails,
              callingNumber: { countryCode: 91, phoneNo: "" },
            },
          },
        };
      }

      // setting initialCityMapping
      if (
        body?.serviceTypeId === 4 &&
        body?.gymInfo?.cityMapping?.cityMappingEnabled !== undefined &&
        body?.gymInfo?.cityMapping?.cityMappingEnabled !== null
      ) {
        setInitialCityMapping((prev) => body?.gymInfo?.cityMapping ?? {});
      }

      setProviderToCreate(body);
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };
    createServiceUtil.getServiceProviderById(
      serviceProviderId ?? props.data.serviceProviderId,
      onResponse,
      onError,
    );
  };

  const isMessageEffectivelyEmpty = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.trim() === "";
  };

  let verifyData = () => {
    if (serviceProviderView == 0) {
      EventService.emit("showError", {
        message: "Please select service type",
      });
      return;
    } else {
      if (serviceProviderView == 1) {
        const hasEmptySlot = Object.keys(
          providerToCreate.consultationInfo.availability.schedule,
        ).some((day) =>
          providerToCreate.consultationInfo.availability.schedule[day].some(
            (slot) => slot.start === "" || slot.end === "",
          ),
        );

        if (
          providerToCreate.serviceTypeId == null ||
          providerToCreate.serviceTypeId == ""
        ) {
          EventService.emit("showError", {
            message: "Please select service type",
          });
          return;
        } else if (
          providerToCreate.isActive == null ||
          providerToCreate.isActive == ""
        ) {
          EventService.emit("showError", {
            message: "Please select service provider status",
          });
          return;
        } else if (
          providerToCreate.consultationInfo.identityDetails.doctorId == null ||
          providerToCreate.consultationInfo.identityDetails.doctorId == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill the doctor ID",
          });
          return;
        } else if (
          providerToCreate.consultationInfo.identityDetails.licenseNo == null ||
          providerToCreate.consultationInfo.identityDetails.licenseNo.trim() ==
            ""
        ) {
          EventService.emit("showError", {
            message: "Doctor license number is empty, enter correct expert ID",
          });
          return;
        } else if (
          providerToCreate.consultationInfo.identityDetails.namePrefix ==
            null ||
          providerToCreate.consultationInfo.identityDetails.namePrefix.trim() ==
            ""
        ) {
          EventService.emit("showError", {
            message: "Doctor prefix is empty, enter correct expert ID",
          });
          return;
        } else if (
          providerToCreate.consultationInfo.identityDetails.name == null ||
          providerToCreate.consultationInfo.identityDetails.name.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please update service provider name",
          });
          return;
        } else if (
          providerToCreate.serviceSubtypeId == null ||
          providerToCreate.serviceSubtypeId == ""
        ) {
          EventService.emit("showError", {
            message: "Please select service subtype",
          });
          return;
        } else if (
          providerToCreate.consultationInfo.identityDetails.mobileCover ==
            null ||
          providerToCreate.consultationInfo.identityDetails.mobileCover == ""
        ) {
          EventService.emit("showError", {
            message: "Please update Image (Mobile view) for the expert ID",
          });
          return;
        } else if (
          providerToCreate.consultationInfo.identityDetails.practiceStartDate ==
            null ||
          providerToCreate.consultationInfo.identityDetails.practiceStartDate ==
            ""
        ) {
          EventService.emit("showError", {
            message: "Please fill Service provider practice start date",
          });
          return;
        } else if (
          providerToCreate.consultationInfo.identityDetails.languages == null ||
          providerToCreate.consultationInfo.identityDetails.languages.length ==
            0
        ) {
          EventService.emit("showError", {
            message: "Please fill languages known",
          });
          return;
        } else if (
          providerToCreate.consultationInfo.identityDetails.shortdescription ==
            null ||
          providerToCreate.consultationInfo.identityDetails.shortdescription.trim() ==
            ""
        ) {
          EventService.emit("showError", {
            message: "Please fill Service provider short description",
          });
          return;
        } else if (
          providerToCreate.consultationInfo.identityDetails.longDescription ==
            null ||
          isMessageEffectivelyEmpty(
            providerToCreate.consultationInfo.identityDetails.longDescription,
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill Service provider long description",
          });
          return;
        } else if (
          providerToCreate.consultationInfo.contactDetails.contactNumber
            .countryCode == null ||
          providerToCreate.consultationInfo.contactDetails.contactNumber
            .countryCode == "" ||
          !(
            Number.isInteger(
              providerToCreate.consultationInfo.contactDetails.contactNumber
                .countryCode,
            ) &&
            providerToCreate.consultationInfo.contactDetails.contactNumber
              .countryCode > 0
          )
        ) {
          EventService.emit("showError", {
            message: "Please update service provider phone country code",
          });
          return;
        } else if (
          providerToCreate.consultationInfo.contactDetails.contactNumber
            .phoneNo == null ||
          providerToCreate.consultationInfo.contactDetails.contactNumber
            .phoneNo == "" ||
          !(
            Number.isInteger(
              providerToCreate.consultationInfo.contactDetails.contactNumber
                .phoneNo,
            ) &&
            providerToCreate.consultationInfo.contactDetails.contactNumber
              .phoneNo > 0
          )
        ) {
          EventService.emit("showError", {
            message: "Please update service provider phone number",
          });
          return;
        } else if (
          providerToCreate.consultationInfo.contactDetails
            .alternateContactNumber &&
          providerToCreate.consultationInfo.contactDetails
            .alternateContactNumber.length != 0 &&
          providerToCreate.consultationInfo.contactDetails.alternateContactNumber.some(
            (item) =>
              item.phoneNo != "" &&
              item.phoneNo.toString().length != phoneNoLen(item.countryCode),
          )
        ) {
          EventService.emit("showError", {
            message: `Wrong alternate phone number length`,
          });
          return;
        } else if (
          providerToCreate?.consultationInfo?.contactDetails?.callingNumber
            ?.phoneNo != "" &&
          providerToCreate?.consultationInfo?.contactDetails?.callingNumber?.phoneNo.toString()
            .length !=
            phoneNoLen(
              providerToCreate?.consultationInfo?.contactDetails?.callingNumber
                ?.countryCode,
            )
        ) {
          EventService.emit("showError", {
            message: `Calling number should be of length ${phoneNoLen(
              providerToCreate?.consultationInfo?.contactDetails?.callingNumber
                ?.countryCode,
            )}`,
          });
          return;
        } else if (
          providerToCreate?.consultationInfo?.contactDetails
            ?.bookingContactNumber &&
          providerToCreate?.consultationInfo?.contactDetails
            ?.bookingContactNumber.length > 0 &&
          providerToCreate?.consultationInfo?.contactDetails?.bookingContactNumber.some(
            (item, index) => {
              if (item.phoneNo !== "") {
                return (
                  item.phoneNo.toString().length !==
                  phoneNoLen(item.countryCode)
                );
              }
              return false;
            },
          )
        ) {
          EventService.emit("showError", {
            message: `Wrong booking phone number length`,
          });
          return;
        } else if (
          providerToCreate.consultationInfo.contactDetails.spoc != null &&
          providerToCreate.consultationInfo.contactDetails.spoc.length > 0 &&
          providerToCreate.consultationInfo.contactDetails.spoc.some(
            (item) =>
              !(item.emailId == "" && item.name == "" && item.phoneNo == "") &&
              item.phoneNo.toString().length != phoneNoLen(item.countryCode),
          )
        ) {
          EventService.emit("showError", {
            message: `Wrong Spoc phone number length`,
          });
          return;
        } else if (
          providerToCreate.consultationInfo.contactDetails.spoc != null &&
          providerToCreate.consultationInfo.contactDetails.spoc.length > 0 &&
          providerToCreate.consultationInfo.contactDetails.spoc.some(
            (item) => !isValidLandline(item.landline),
          )
        ) {
          EventService.emit("showError", {
            message: `Invalid Spoc landline number`,
          });
          return;
        } else if (hasEmptySlot) {
          EventService.emit("showError", {
            message: "Please fill all the slots in the schedule",
          });
          return;
        } else {
          let body = providerToCreate;
          body = {
            ...body,
            isActive: body.isActive == "true" ? true : false,
            checkupInfo: null,
          };
          if (
            providerToCreate?.consultationInfo?.contactDetails?.callingNumber
              ?.phoneNo == ""
          ) {
            body = {
              ...body,
              consultationInfo: {
                ...body.consultationInfo,
                contactDetails: {
                  ...body.consultationInfo.contactDetails,
                  callingNumber: null,
                },
              },
            };
          }
          if (
            providerToCreate?.consultationInfo?.contactDetails
              ?.bookingContactNumber[0]?.phoneNo == ""
          ) {
            body = {
              ...body,
              consultationInfo: {
                ...body.consultationInfo,
                contactDetails: {
                  ...body.consultationInfo.contactDetails,
                  bookingContactNumber: null,
                },
              },
            };
          }
          let be =
            providerToCreate?.consultationInfo?.contactDetails?.bookingEmails?.filter(
              (element) => element !== "",
            );
          if (
            providerToCreate?.consultationInfo?.contactDetails?.bookingEmails
              .length > 0
          ) {
            body = {
              ...body,
              consultationInfo: {
                ...body.consultationInfo,
                contactDetails: {
                  ...body.consultationInfo.contactDetails,
                  bookingEmails: be.length === 0 ? null : be,
                },
              },
            };
          }
          if (
            providerToCreate.consultationInfo.contactDetails
              .alternateContactNumber &&
            providerToCreate.consultationInfo.contactDetails
              .alternateContactNumber.length != 0
          ) {
            let newAltContact =
              providerToCreate.consultationInfo.contactDetails.alternateContactNumber.filter(
                (e) => {
                  return e.phoneNo == "" ? false : true;
                },
              );
            body = {
              ...body,
              consultationInfo: {
                ...body.consultationInfo,
                contactDetails: {
                  ...body.consultationInfo.contactDetails,
                  alternateContactNumber: newAltContact,
                },
              },
            };
          }
          if (
            body.consultationInfo.contactDetails.spoc != null &&
            body.consultationInfo.contactDetails.spoc.length > 0
          ) {
            let newSpoc = body.consultationInfo.contactDetails.spoc.filter(
              (e) => !(e.emailId == "" && e.name == "" && e.phoneNo == ""),
            );

            body = {
              ...body,
              consultationInfo: {
                ...body.consultationInfo,
                contactDetails: {
                  ...body.consultationInfo.contactDetails,
                  spoc: newSpoc,
                },
              },
            };
          }
          if (
            body.consultationInfo.availability.config.slotDurationInMinutes ==
            ""
          ) {
            body = {
              ...body,
              consultationInfo: {
                ...body.consultationInfo,
                availability: {
                  ...body.consultationInfo.availability,
                  config: {
                    ...body.consultationInfo.availability.config,
                    slotDurationInMinutes: 0,
                  },
                },
              },
            };
          }
          if (body.consultationInfo.availability.config.bookingPerSlot == "") {
            body = {
              ...body,
              consultationInfo: {
                ...body.consultationInfo,
                availability: {
                  ...body.consultationInfo.availability,
                  config: {
                    ...body.consultationInfo.availability.config,
                    bookingPerSlot: 0,
                  },
                },
              },
            };
          }
          if (body.consultationInfo.availability.config.minBookingDays == "") {
            body = {
              ...body,
              consultationInfo: {
                ...body.consultationInfo,
                availability: {
                  ...body.consultationInfo.availability,
                  config: {
                    ...body.consultationInfo.availability.config,
                    minBookingDays: 0,
                  },
                },
              },
            };
          }
          if (
            body.consultationInfo.availability.config.maxAdvBookingDays == ""
          ) {
            body = {
              ...body,
              consultationInfo: {
                ...body.consultationInfo,
                availability: {
                  ...body.consultationInfo.availability,
                  config: {
                    ...body.consultationInfo.availability.config,
                    maxAdvBookingDays: 0,
                  },
                },
              },
            };
          }

          body = {
            ...body,
            checkupInfo: null,
            vaccineInfo: null,
            gymInfo: null,
            dentalInfo: null,
          };

          mode == 3
            ? updateServiceProvider(body)
            : createNewServiceProvider(body);
        }
      } else if (serviceProviderView == 2) {
        const hasEmptySlot = Object.keys(
          providerToCreate.checkupInfo.availability.schedule,
        ).some((day) =>
          providerToCreate.checkupInfo.availability.schedule[day].some(
            (slot) => slot.start === "" || slot.end === "",
          ),
        );
        if (
          providerToCreate.serviceTypeId == null ||
          providerToCreate.serviceTypeId == ""
        ) {
          EventService.emit("showError", {
            message: "Please select service type",
          });
          return;
        }
        // else if (
        //   providerToCreate.serviceSubtypeId == null ||
        //   providerToCreate.serviceSubtypeId == ""
        // ) {
        //   EventService.emit("showError", {
        //     message: "Please select service subtype",
        //   });
        //   return;
        // }
        else if (
          providerToCreate.isActive == null ||
          providerToCreate.isActive == ""
        ) {
          EventService.emit("showError", {
            message: "Please select service provider status",
          });
          return;
        } else if (
          providerToCreate.checkupInfo.identityDetails.name == null ||
          providerToCreate.checkupInfo.identityDetails.name.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill the service provider name",
          });
          return;
        }
        // else if (
        //   providerToCreate.checkupInfo.identityDetails.shortdescription ==
        //     null ||
        //   providerToCreate.checkupInfo.identityDetails.shortdescription.trim() ==
        //     ""
        // ) {
        //   EventService.emit("showError", {
        //     message: "Please fill Service provider short description",
        //   });
        //   return;
        // }
        else if (
          providerToCreate.checkupInfo.identityDetails.mobileCover == null ||
          providerToCreate.checkupInfo.identityDetails.mobileCover == ""
        ) {
          EventService.emit("showError", {
            message: "Please upload Image (Mobile view)",
          });
          return;
        } else if (
          providerToCreate.checkupInfo.contactDetails.bookingEmailId == null ||
          providerToCreate.checkupInfo.contactDetails.bookingEmailId.trim() ==
            ""
        ) {
          EventService.emit("showError", {
            message: "Please fill Service provider booking Email Id",
          });
          return;
        } else if (
          providerToCreate.checkupInfo.contactDetails.spoc == undefined
        ) {
          EventService.emit("showError", {
            message: "Please fill all SPOC 1 details",
          });
          return;
        } else if (
          providerToCreate.checkupInfo.contactDetails.spoc[0].name.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill all SPOC 1 name",
          });
          return;
        } else if (
          providerToCreate.checkupInfo.contactDetails.spoc != null &&
          providerToCreate.checkupInfo.contactDetails.spoc.length > 0 &&
          providerToCreate.checkupInfo.contactDetails.spoc.some(
            (item) =>
              !(item.emailId == "" && item.name == "" && item.phoneNo == "") &&
              item.phoneNo.toString().length != phoneNoLen(item.countryCode),
          )
        ) {
          EventService.emit("showError", {
            message: `Wrong Spoc phone number length`,
          });
          return;
        } else if (
          providerToCreate.checkupInfo.contactDetails.spoc != null &&
          providerToCreate.checkupInfo.contactDetails.spoc.length > 0 &&
          providerToCreate.checkupInfo.contactDetails.spoc.some(
            (item) => !isValidLandline(item.landline),
          )
        ) {
          EventService.emit("showError", {
            message: `Invalid Spoc landline number`,
          });
          return;
        } else if (!(
          typeof providerToCreate.checkupInfo.contactDetails.spoc[0].phoneNo ===
            "number" &&
          providerToCreate.checkupInfo.contactDetails.spoc[0].phoneNo > 0 &&
          Number.isInteger(
            providerToCreate.checkupInfo.contactDetails.spoc[0].phoneNo,
          ) &&
          providerToCreate.checkupInfo.contactDetails.spoc[0].phoneNo.toString()
            .length === 10
        )) {
          EventService.emit("showError", {
            message: "Please fill SPOC 1 phone number of length 10",
          });
          return;
        } else if (
          providerToCreate.checkupInfo.contactDetails.spoc[0].emailId.trim() ==
          ""
        ) {
          EventService.emit("showError", {
            message: "Please fill  SPOC 1 email",
          });
          return;
        } else if (
          providerToCreate.checkupInfo.address.pincode == null ||
          providerToCreate.checkupInfo.address.pincode == "" ||
          !(
            typeof providerToCreate.checkupInfo.address.pincode === "number" &&
            providerToCreate.checkupInfo.address.pincode > 0 &&
            Number.isInteger(providerToCreate.checkupInfo.address.pincode) &&
            providerToCreate.checkupInfo.address.pincode.toString().length === 6
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill 6 digit pincode code in the address",
          });
          return;
        } else if (
          providerToCreate.checkupInfo.address.city == null ||
          providerToCreate.checkupInfo.address.city.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill city in the address",
          });
          return;
        } else if (
          providerToCreate.checkupInfo.address.district == null ||
          providerToCreate.checkupInfo.address.district.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill district in the address",
          });
          return;
        } else if (
          providerToCreate.checkupInfo.address.state == null ||
          providerToCreate.checkupInfo.address.state.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill state in the address",
          });
          return;
        } else if (
          providerToCreate.checkupInfo.address.landmark == null ||
          providerToCreate.checkupInfo.address.landmark.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill locality in the address",
          });
          return;
        } else if (
          providerToCreate.checkupInfo.availability.config
            .slotDurationInMinutes === null ||
          providerToCreate.checkupInfo.availability.config
            .slotDurationInMinutes === "" ||
          !(
            Number.isInteger(
              providerToCreate.checkupInfo.availability.config
                .slotDurationInMinutes,
            ) &&
            providerToCreate.checkupInfo.availability.config
              .slotDurationInMinutes > 0
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill slot duration in minutes",
          });
          return;
        } else if (
          providerToCreate.checkupInfo.availability.config.bookingPerSlot ===
            null ||
          providerToCreate.checkupInfo.availability.config.bookingPerSlot ===
            "" ||
          !(
            Number.isInteger(
              providerToCreate.checkupInfo.availability.config.bookingPerSlot,
            ) &&
            providerToCreate.checkupInfo.availability.config.bookingPerSlot > 0
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill booking per slot",
          });
          return;
        } else if (
          providerToCreate.checkupInfo.availability.config.minBookingDays ===
            null ||
          providerToCreate.checkupInfo.availability.config.minBookingDays ===
            "" ||
          !(
            Number.isInteger(
              providerToCreate.checkupInfo.availability.config.minBookingDays,
            ) &&
            providerToCreate.checkupInfo.availability.config.minBookingDays >= 0
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill min booking notice",
          });
          return;
        } else if (
          providerToCreate.checkupInfo.availability.config.maxAdvBookingDays ===
            null ||
          providerToCreate.checkupInfo.availability.config.maxAdvBookingDays ===
            "" ||
          !(
            Number.isInteger(
              providerToCreate.checkupInfo.availability.config
                .maxAdvBookingDays,
            ) &&
            providerToCreate.checkupInfo.availability.config.maxAdvBookingDays >
              0
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill max advance booking days",
          });
          return;
        } else if (hasEmptySlot) {
          EventService.emit("showError", {
            message: "Please fill all the slots in the schedule",
          });
          return;
        } else {
          let body = providerToCreate;
          body = {
            ...body,
            isActive: body.isActive == "true" ? true : false,
            consultationInfo: null,
          };
          if (
            body.checkupInfo.contactDetails.alternateBookingEmails != null &&
            body.checkupInfo.contactDetails.alternateBookingEmails.length > 0
          ) {
            let newAltEmail =
              body.checkupInfo.contactDetails.alternateBookingEmails.filter(
                (e) => e != "",
              );

            body = {
              ...body,
              checkupInfo: {
                ...body.checkupInfo,
                contactDetails: {
                  ...body.checkupInfo.contactDetails,
                  alternateBookingEmails: newAltEmail,
                },
              },
            };
          }
          if (
            body.checkupInfo.contactDetails.spoc != null &&
            body.checkupInfo.contactDetails.spoc.length > 0
          ) {
            let newSpoc = body.checkupInfo.contactDetails.spoc.filter(
              (e) => !(e.emailId == "" && e.name == "" && e.phoneNo == ""),
            );

            body = {
              ...body,
              checkupInfo: {
                ...body.checkupInfo,
                contactDetails: {
                  ...body.checkupInfo.contactDetails,
                  spoc: newSpoc,
                },
              },
            };
          }

          body = {
            ...body,
            consultationInfo: null,
            vaccineInfo: null,
            gymInfo: null,
            dentalInfo: null,
          };

          if (mode == 3) {
            body = {
              ...body,
              consultationInfo: null,
            };

            updateServiceProvider(body);
          } else {
            createNewServiceProvider(body);
          }
        }
      } else if (serviceProviderView == 3) {
        const hasEmptySlot = Object.keys(
          providerToCreate.vaccineInfo.availability.schedule,
        ).some((day) =>
          providerToCreate.vaccineInfo.availability.schedule[day].some(
            (slot) => slot.start === "" || slot.end === "",
          ),
        );
        if (
          providerToCreate.serviceTypeId == null ||
          providerToCreate.serviceTypeId == ""
        ) {
          EventService.emit("showError", {
            message: "Please select service type",
          });
          return;
        }
        // else if (
        //   providerToCreate.serviceSubtypeId == null ||
        //   providerToCreate.serviceSubtypeId == ""
        // ) {
        //   EventService.emit("showError", {
        //     message: "Please select service subtype",
        //   });
        //   return;
        // }
        else if (
          providerToCreate.isActive == null ||
          providerToCreate.isActive == ""
        ) {
          EventService.emit("showError", {
            message: "Please select service provider status",
          });
          return;
        } else if (
          providerToCreate.vaccineInfo.identityDetails.name == null ||
          providerToCreate.vaccineInfo.identityDetails.name.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill the service provider name",
          });
          return;
        }
        // else if (
        //   providerToCreate.vaccineInfo.identityDetails.shortdescription ==
        //     null ||
        //   providerToCreate.vaccineInfo.identityDetails.shortdescription.trim() ==
        //     ""
        // ) {
        //   EventService.emit("showError", {
        //     message: "Please fill Service provider short description",
        //   });
        //   return;
        // }
        else if (
          providerToCreate.vaccineInfo.identityDetails.mobileCover == null ||
          providerToCreate.vaccineInfo.identityDetails.mobileCover == ""
        ) {
          EventService.emit("showError", {
            message: "Please upload Image (Mobile view)",
          });
          return;
        } else if (
          providerToCreate.vaccineInfo.contactDetails.bookingEmailId == null ||
          providerToCreate.vaccineInfo.contactDetails.bookingEmailId.trim() ==
            ""
        ) {
          EventService.emit("showError", {
            message: "Please fill Service provider booking Email Id",
          });
          return;
        } else if (
          providerToCreate.vaccineInfo.contactDetails.spoc == undefined
        ) {
          EventService.emit("showError", {
            message: "Please fill all SPOC 1 details",
          });
          return;
        } else if (
          providerToCreate.vaccineInfo.contactDetails.spoc[0].name.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill all SPOC 1 name",
          });
          return;
        } else if (
          providerToCreate.vaccineInfo.contactDetails.spoc != null &&
          providerToCreate.vaccineInfo.contactDetails.spoc.length > 0 &&
          providerToCreate.vaccineInfo.contactDetails.spoc.some(
            (item) =>
              !(item.emailId == "" && item.name == "" && item.phoneNo == "") &&
              item.phoneNo.toString().length != phoneNoLen(item.countryCode),
          )
        ) {
          EventService.emit("showError", {
            message: `Wrong Spoc phone number length`,
          });
          return;
        } else if (
          providerToCreate.vaccineInfo.contactDetails.spoc != null &&
          providerToCreate.vaccineInfo.contactDetails.spoc.length > 0 &&
          providerToCreate.vaccineInfo.contactDetails.spoc.some(
            (item) => !isValidLandline(item.landline),
          )
        ) {
          EventService.emit("showError", {
            message: `Invalid Spoc landline number`,
          });
          return;
        } else if (!(
          typeof providerToCreate.vaccineInfo.contactDetails.spoc[0].phoneNo ===
            "number" &&
          providerToCreate.vaccineInfo.contactDetails.spoc[0].phoneNo > 0 &&
          Number.isInteger(
            providerToCreate.vaccineInfo.contactDetails.spoc[0].phoneNo,
          ) &&
          providerToCreate.vaccineInfo.contactDetails.spoc[0].phoneNo.toString()
            .length === 10
        )) {
          EventService.emit("showError", {
            message: "Please fill SPOC 1 phone number of length 10",
          });
          return;
        } else if (
          providerToCreate.vaccineInfo.contactDetails.spoc[0].emailId.trim() ==
          ""
        ) {
          EventService.emit("showError", {
            message: "Please fill  SPOC 1 email",
          });
          return;
        } else if (
          providerToCreate.vaccineInfo.address.pincode == null ||
          providerToCreate.vaccineInfo.address.pincode == "" ||
          !(
            typeof providerToCreate.vaccineInfo.address.pincode === "number" &&
            providerToCreate.vaccineInfo.address.pincode > 0 &&
            Number.isInteger(providerToCreate.vaccineInfo.address.pincode) &&
            providerToCreate.vaccineInfo.address.pincode.toString().length === 6
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill 6 digit pincode code in the address",
          });
          return;
        } else if (
          providerToCreate.vaccineInfo.address.city == null ||
          providerToCreate.vaccineInfo.address.city.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill city in the address",
          });
          return;
        } else if (
          providerToCreate.vaccineInfo.address.district == null ||
          providerToCreate.vaccineInfo.address.district.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill district in the address",
          });
          return;
        } else if (
          providerToCreate.vaccineInfo.address.state == null ||
          providerToCreate.vaccineInfo.address.state.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill state in the address",
          });
          return;
        } else if (
          providerToCreate.vaccineInfo.address.landmark == null ||
          providerToCreate.vaccineInfo.address.landmark.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill locality in the address",
          });
          return;
        } else if (
          providerToCreate.vaccineInfo.availability.config
            .slotDurationInMinutes === null ||
          providerToCreate.vaccineInfo.availability.config
            .slotDurationInMinutes === "" ||
          !(
            Number.isInteger(
              providerToCreate.vaccineInfo.availability.config
                .slotDurationInMinutes,
            ) &&
            providerToCreate.vaccineInfo.availability.config
              .slotDurationInMinutes > 0
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill slot duration in minutes",
          });
          return;
        } else if (
          providerToCreate.vaccineInfo.availability.config.bookingPerSlot ===
            null ||
          providerToCreate.vaccineInfo.availability.config.bookingPerSlot ===
            "" ||
          !(
            Number.isInteger(
              providerToCreate.vaccineInfo.availability.config.bookingPerSlot,
            ) &&
            providerToCreate.vaccineInfo.availability.config.bookingPerSlot > 0
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill booking per slot",
          });
          return;
        } else if (
          providerToCreate.vaccineInfo.availability.config.minBookingDays ===
            null ||
          providerToCreate.vaccineInfo.availability.config.minBookingDays ===
            "" ||
          !(
            Number.isInteger(
              providerToCreate.vaccineInfo.availability.config.minBookingDays,
            ) &&
            providerToCreate.vaccineInfo.availability.config.minBookingDays >= 0
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill min booking notice",
          });
          return;
        } else if (
          providerToCreate.vaccineInfo.availability.config.maxAdvBookingDays ===
            null ||
          providerToCreate.vaccineInfo.availability.config.maxAdvBookingDays ===
            "" ||
          !(
            Number.isInteger(
              providerToCreate.vaccineInfo.availability.config
                .maxAdvBookingDays,
            ) &&
            providerToCreate.vaccineInfo.availability.config.maxAdvBookingDays >
              0
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill max advance booking days",
          });
          return;
        } else if (hasEmptySlot) {
          EventService.emit("showError", {
            message: "Please fill all the slots in the schedule",
          });
          return;
        } else {
          let body = providerToCreate;
          body = {
            ...body,
            isActive: body.isActive == "true" ? true : false,
            consultationInfo: null,
          };
          if (
            body.vaccineInfo.contactDetails.alternateBookingEmails != null &&
            body.vaccineInfo.contactDetails.alternateBookingEmails.length > 0
          ) {
            let newAltEmail =
              body.vaccineInfo.contactDetails.alternateBookingEmails.filter(
                (e) => e != "",
              );

            body = {
              ...body,
              vaccineInfo: {
                ...body.vaccineInfo,
                contactDetails: {
                  ...body.vaccineInfo.contactDetails,
                  alternateBookingEmails: newAltEmail,
                },
              },
            };
          }
          if (
            body.vaccineInfo.contactDetails.spoc != null &&
            body.vaccineInfo.contactDetails.spoc.length > 0
          ) {
            let newSpoc = body.vaccineInfo.contactDetails.spoc.filter(
              (e) => !(e.emailId == "" && e.name == "" && e.phoneNo == ""),
            );

            body = {
              ...body,
              vaccineInfo: {
                ...body.vaccineInfo,
                contactDetails: {
                  ...body.vaccineInfo.contactDetails,
                  spoc: newSpoc,
                },
              },
            };
          }

          body = {
            ...body,
            checkupInfo: null,
            consultationInfo: null,
            gymInfo: null,
            dentalInfo: null,
          };

          if (mode == 3) {
            body = {
              ...body,
              consultationInfo: null,
            };

            updateServiceProvider(body);
          } else {
            createNewServiceProvider(body);
          }
        }
      } else if (serviceProviderView == 4) {
        if (
          providerToCreate.serviceTypeId == null ||
          providerToCreate.serviceTypeId == ""
        ) {
          EventService.emit("showError", {
            message: "Please select service type",
          });
          return;
        }
        // else if (
        //   providerToCreate.serviceSubtypeId == null ||
        //   providerToCreate.serviceSubtypeId == ""
        // ) {
        //   EventService.emit("showError", {
        //     message: "Please select service subtype",
        //   });
        //   return;
        // }
        else if (
          providerToCreate.isActive == null ||
          providerToCreate.isActive == ""
        ) {
          EventService.emit("showError", {
            message: "Please select service provider status",
          });
          return;
        } else if (
          providerToCreate.gymInfo.identityDetails.name == null ||
          providerToCreate.gymInfo.identityDetails.name.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill the service provider name",
          });
          return;
        }
        // else if (
        //   providerToCreate.dentalInfo.identityDetails.shortdescription ==
        //     null ||
        //   providerToCreate.dentalInfo.identityDetails.shortdescription.trim() ==
        //     ""
        // ) {
        //   EventService.emit("showError", {
        //     message: "Please fill Service provider short description",
        //   });
        //   return;
        // }
        else if (
          providerToCreate.gymInfo.identityDetails.mobileCover == null ||
          providerToCreate.gymInfo.identityDetails.mobileCover == ""
        ) {
          EventService.emit("showError", {
            message: "Please upload Image (Mobile view)",
          });
          return;
        } else if (
          providerToCreate.gymInfo.contactDetails.bookingEmailId == null ||
          providerToCreate.gymInfo.contactDetails.bookingEmailId.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill Service provider booking Email Id",
          });
          return;
        } else if (providerToCreate.gymInfo.contactDetails.spoc == undefined) {
          EventService.emit("showError", {
            message: "Please fill all SPOC 1 details",
          });
          return;
        } else if (
          providerToCreate.gymInfo.contactDetails.spoc[0].name.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill all SPOC 1 name",
          });
          return;
        } else if (
          providerToCreate.gymInfo.contactDetails.spoc != null &&
          providerToCreate.gymInfo.contactDetails.spoc.length > 0 &&
          providerToCreate.gymInfo.contactDetails.spoc.some(
            (item) =>
              !(item.emailId == "" && item.name == "" && item.phoneNo == "") &&
              item.phoneNo.toString().length != phoneNoLen(item.countryCode),
          )
        ) {
          EventService.emit("showError", {
            message: `Wrong Spoc phone number length`,
          });
          return;
        } else if (
          providerToCreate.gymInfo.contactDetails.spoc != null &&
          providerToCreate.gymInfo.contactDetails.spoc.length > 0 &&
          providerToCreate.gymInfo.contactDetails.spoc.some(
            (item) => !isValidLandline(item.landline),
          )
        ) {
          EventService.emit("showError", {
            message: `Invalid Spoc landline number`,
          });
          return;
        } else if (!(
          typeof providerToCreate.gymInfo.contactDetails.spoc[0].phoneNo ===
            "number" &&
          providerToCreate.gymInfo.contactDetails.spoc[0].phoneNo > 0 &&
          Number.isInteger(
            providerToCreate.gymInfo.contactDetails.spoc[0].phoneNo,
          ) &&
          providerToCreate.gymInfo.contactDetails.spoc[0].phoneNo.toString()
            .length === 10
        )) {
          EventService.emit("showError", {
            message: "Please fill SPOC 1 phone number of length 10",
          });
          return;
        } else if (
          providerToCreate.gymInfo.contactDetails.spoc[0].emailId.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill  SPOC 1 email",
          });
          return;
        } else if (
          providerToCreate.gymInfo.address.pincode == null ||
          providerToCreate.gymInfo.address.pincode == "" ||
          !(
            typeof providerToCreate.gymInfo.address.pincode === "number" &&
            providerToCreate.gymInfo.address.pincode > 0 &&
            Number.isInteger(providerToCreate.gymInfo.address.pincode) &&
            providerToCreate.gymInfo.address.pincode.toString().length === 6
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill 6 digit pincode code in the address",
          });
          return;
        } else if (
          providerToCreate.gymInfo.address.city == null ||
          providerToCreate.gymInfo.address.city.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill city in the address",
          });
          return;
        } else if (
          providerToCreate.gymInfo.address.district == null ||
          providerToCreate.gymInfo.address.district.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill district in the address",
          });
          return;
        } else if (
          providerToCreate.gymInfo.address.state == null ||
          providerToCreate.gymInfo.address.state.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill state in the address",
          });
          return;
        } else if (
          providerToCreate.gymInfo.address.landmark == null ||
          providerToCreate.gymInfo.address.landmark.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill locality in the address",
          });
          return;
        } else {
          let body = providerToCreate;
          body = {
            ...body,
            isActive: body.isActive == "true" ? true : false,
            consultationInfo: null,
            gymInfo: {
              ...body.gymInfo,
              availability: {
                config: {},
                schedule: {
                  sunday: [],
                  monday: [],
                  tuesday: [],
                  wednesday: [],
                  thursday: [],
                  friday: [],
                  saturday: [],
                },
                unavailableTime: [],
                availableTime: [],
              },
            },
          };
          if (
            body.gymInfo.contactDetails.alternateBookingEmails != null &&
            body.gymInfo.contactDetails.alternateBookingEmails.length > 0
          ) {
            let newAltEmail =
              body.gymInfo.contactDetails.alternateBookingEmails.filter(
                (e) => e != "",
              );

            body = {
              ...body,
              gymInfo: {
                ...body.gymInfo,
                contactDetails: {
                  ...body.gymInfo.contactDetails,
                  alternateBookingEmails: newAltEmail,
                },
              },
            };
          }
          if (
            body.gymInfo.contactDetails.spoc != null &&
            body.gymInfo.contactDetails.spoc.length > 0
          ) {
            let newSpoc = body.gymInfo.contactDetails.spoc.filter(
              (e) => !(e.emailId == "" && e.name == "" && e.phoneNo == ""),
            );

            body = {
              ...body,
              gymInfo: {
                ...body.gymInfo,
                contactDetails: {
                  ...body.gymInfo.contactDetails,
                  spoc: newSpoc,
                },
              },
            };
          }

          body = {
            ...body,
            checkupInfo: null,
            consultationInfo: null,
            vaccineInfo: null,
            dentalInfo: null,
          };

          if (mode == 3) {
            body = {
              ...body,
              consultationInfo: null,
            };

            updateServiceProvider(
              body,
              undefined,
              !(initialCityMapping?.cityMappingEnabled ?? false) &&
                (providerToCreate?.gymInfo?.cityMapping?.cityMappingEnabled ??
                  false) == true,
            );
          } else {
            createNewServiceProvider(
              body,
              (providerToCreate?.gymInfo?.cityMapping?.cityMappingEnabled ??
                false) == true,
            );
          }
        }
      } else if (serviceProviderView == 5) {
        const hasEmptySlot = Object.keys(
          providerToCreate.dentalInfo.availability.schedule,
        ).some((day) =>
          providerToCreate.dentalInfo.availability.schedule[day].some(
            (slot) => slot.start === "" || slot.end === "",
          ),
        );
        if (
          providerToCreate.serviceTypeId == null ||
          providerToCreate.serviceTypeId == ""
        ) {
          EventService.emit("showError", {
            message: "Please select service type",
          });
          return;
        }
        // else if (
        //   providerToCreate.serviceSubtypeId == null ||
        //   providerToCreate.serviceSubtypeId == ""
        // ) {
        //   EventService.emit("showError", {
        //     message: "Please select service subtype",
        //   });
        //   return;
        // }
        else if (
          providerToCreate.isActive == null ||
          providerToCreate.isActive == ""
        ) {
          EventService.emit("showError", {
            message: "Please select service provider status",
          });
          return;
        } else if (
          providerToCreate.dentalInfo.identityDetails.name == null ||
          providerToCreate.dentalInfo.identityDetails.name.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill the service provider name",
          });
          return;
        }
        // else if (
        //   providerToCreate.vaccineInfo.identityDetails.shortdescription ==
        //     null ||
        //   providerToCreate.vaccineInfo.identityDetails.shortdescription.trim() ==
        //     ""
        // ) {
        //   EventService.emit("showError", {
        //     message: "Please fill Service provider short description",
        //   });
        //   return;
        // }
        else if (
          providerToCreate.dentalInfo.identityDetails.mobileCover == null ||
          providerToCreate.dentalInfo.identityDetails.mobileCover == ""
        ) {
          EventService.emit("showError", {
            message: "Please upload Image (Mobile view)",
          });
          return;
        } else if (
          providerToCreate.dentalInfo.contactDetails.bookingEmailId == null ||
          providerToCreate.dentalInfo.contactDetails.bookingEmailId.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill Service provider booking Email Id",
          });
          return;
        } else if (
          providerToCreate.dentalInfo.contactDetails.spoc == undefined
        ) {
          EventService.emit("showError", {
            message: "Please fill all SPOC 1 details",
          });
          return;
        } else if (
          providerToCreate.dentalInfo.contactDetails.spoc[0].name.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill all SPOC 1 name",
          });
          return;
        } else if (
          providerToCreate.dentalInfo.contactDetails.spoc != null &&
          providerToCreate.dentalInfo.contactDetails.spoc.length > 0 &&
          providerToCreate.dentalInfo.contactDetails.spoc.some(
            (item) =>
              !(item.emailId == "" && item.name == "" && item.phoneNo == "") &&
              item.phoneNo.toString().length != phoneNoLen(item.countryCode),
          )
        ) {
          EventService.emit("showError", {
            message: `Wrong Spoc phone number length`,
          });
          return;
        } else if (
          providerToCreate.dentalInfo.contactDetails.spoc != null &&
          providerToCreate.dentalInfo.contactDetails.spoc.length > 0 &&
          providerToCreate.dentalInfo.contactDetails.spoc.some(
            (item) => !isValidLandline(item.landline),
          )
        ) {
          EventService.emit("showError", {
            message: `Invalid Spoc landline number`,
          });
          return;
        } else if (!(
          typeof providerToCreate.dentalInfo.contactDetails.spoc[0].phoneNo ===
            "number" &&
          providerToCreate.dentalInfo.contactDetails.spoc[0].phoneNo > 0 &&
          Number.isInteger(
            providerToCreate.dentalInfo.contactDetails.spoc[0].phoneNo,
          ) &&
          providerToCreate.dentalInfo.contactDetails.spoc[0].phoneNo.toString()
            .length === 10
        )) {
          EventService.emit("showError", {
            message: "Please fill SPOC 1 phone number of length 10",
          });
          return;
        } else if (
          providerToCreate.dentalInfo.contactDetails.spoc[0].emailId.trim() ==
          ""
        ) {
          EventService.emit("showError", {
            message: "Please fill  SPOC 1 email",
          });
          return;
        } else if (
          providerToCreate.dentalInfo.address.pincode == null ||
          providerToCreate.dentalInfo.address.pincode == "" ||
          !(
            typeof providerToCreate.dentalInfo.address.pincode === "number" &&
            providerToCreate.dentalInfo.address.pincode > 0 &&
            Number.isInteger(providerToCreate.dentalInfo.address.pincode) &&
            providerToCreate.dentalInfo.address.pincode.toString().length === 6
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill 6 digit pincode code in the address",
          });
          return;
        } else if (
          providerToCreate.dentalInfo.address.city == null ||
          providerToCreate.dentalInfo.address.city.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill city in the address",
          });
          return;
        } else if (
          providerToCreate.dentalInfo.address.district == null ||
          providerToCreate.dentalInfo.address.district.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill district in the address",
          });
          return;
        } else if (
          providerToCreate.dentalInfo.address.state == null ||
          providerToCreate.dentalInfo.address.state.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill state in the address",
          });
          return;
        } else if (
          providerToCreate.dentalInfo.address.landmark == null ||
          providerToCreate.dentalInfo.address.landmark.trim() == ""
        ) {
          EventService.emit("showError", {
            message: "Please fill locality in the address",
          });
          return;
        } else if (
          providerToCreate.dentalInfo.availability.config
            .slotDurationInMinutes === null ||
          providerToCreate.dentalInfo.availability.config
            .slotDurationInMinutes === "" ||
          !(
            Number.isInteger(
              providerToCreate.dentalInfo.availability.config
                .slotDurationInMinutes,
            ) &&
            providerToCreate.dentalInfo.availability.config
              .slotDurationInMinutes > 0
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill slot duration in minutes",
          });
          return;
        } else if (
          providerToCreate.dentalInfo.availability.config.bookingPerSlot ===
            null ||
          providerToCreate.dentalInfo.availability.config.bookingPerSlot ===
            "" ||
          !(
            Number.isInteger(
              providerToCreate.dentalInfo.availability.config.bookingPerSlot,
            ) &&
            providerToCreate.dentalInfo.availability.config.bookingPerSlot > 0
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill booking per slot",
          });
          return;
        } else if (
          providerToCreate.dentalInfo.availability.config.minBookingDays ===
            null ||
          providerToCreate.dentalInfo.availability.config.minBookingDays ===
            "" ||
          !(
            Number.isInteger(
              providerToCreate.dentalInfo.availability.config.minBookingDays,
            ) &&
            providerToCreate.dentalInfo.availability.config.minBookingDays >= 0
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill min booking notice",
          });
          return;
        } else if (
          providerToCreate.dentalInfo.availability.config.maxAdvBookingDays ===
            null ||
          providerToCreate.dentalInfo.availability.config.maxAdvBookingDays ===
            "" ||
          !(
            Number.isInteger(
              providerToCreate.dentalInfo.availability.config.maxAdvBookingDays,
            ) &&
            providerToCreate.dentalInfo.availability.config.maxAdvBookingDays >
              0
          )
        ) {
          EventService.emit("showError", {
            message: "Please fill max advance booking days",
          });
          return;
        } else if (hasEmptySlot) {
          EventService.emit("showError", {
            message: "Please fill all the slots in the schedule",
          });
          return;
        } else {
          let body = providerToCreate;
          body = {
            ...body,
            isActive: body.isActive == "true" ? true : false,
            consultationInfo: null,
          };
          if (
            body.dentalInfo.contactDetails.alternateBookingEmails != null &&
            body.dentalInfo.contactDetails.alternateBookingEmails.length > 0
          ) {
            let newAltEmail =
              body.dentalInfo.contactDetails.alternateBookingEmails.filter(
                (e) => e != "",
              );

            body = {
              ...body,
              dentalInfo: {
                ...body.dentalInfo,
                contactDetails: {
                  ...body.dentalInfo.contactDetails,
                  alternateBookingEmails: newAltEmail,
                },
              },
            };
          }
          if (
            body.dentalInfo.contactDetails.spoc != null &&
            body.dentalInfo.contactDetails.spoc.length > 0
          ) {
            let newSpoc = body.dentalInfo.contactDetails.spoc.filter(
              (e) => !(e.emailId == "" && e.name == "" && e.phoneNo == ""),
            );

            body = {
              ...body,
              dentalInfo: {
                ...body.dentalInfo,
                contactDetails: {
                  ...body.dentalInfo.contactDetails,
                  spoc: newSpoc,
                },
              },
            };
          }

          body = {
            ...body,
            checkupInfo: null,
            consultationInfo: null,
            vaccineInfo: null,
            gymInfo: null,
          };

          if (mode == 3) {
            body = {
              ...body,
              consultationInfo: null,
            };

            updateServiceProvider(body);
          } else {
            createNewServiceProvider(body);
          }
        }
      }
    }
  };
  const createNewServiceProvider = (
    payload,
    showUpdateCityMappingNowDialog = false,
  ) => {
    setLoading(true);
    let onResponse = (res) => {
      EventService.emit("showError", {
        message: `Service provider created`,
      });
      setLoading(false);
      if (showUpdateCityMappingNowDialog) {
        setShowUpdateCityMappingNowDialog(true);
        getServiceProvider(res?.id);
      } else {
        props.resetDashboardServiceProvider();
        onExit();
      }
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setLoading(false);
    };
    createServiceProviderUtil.createServiceProvider(
      payload,
      onResponse,
      onError,
    );
  };
  const updateServiceProvider = (
    payload,
    propagate,
    showUpdateCityMappingNowDialog = false,
  ) => {
    if (propagate === undefined) {
      setLoading(true);
      let onResponse = (res) => {
        if (res.updateRequired) {
          setSPbodyToUpdate(payload);
          setOpenPropCalendarChangesDialog(true);
          setLoading(false);
        } else {
          EventService.emit("showError", {
            message: `Service provider updated`,
          });
          setLoading(false);
          if (showUpdateCityMappingNowDialog) {
            setShowUpdateCityMappingNowDialog(true);
            getServiceProvider(res?.id);
          } else {
            props.resetDashboardServiceProvider();
            onExit();
          }
        }
      };
      let onError = (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
        setLoading(false);
      };
      createServiceProviderUtil.updateServiceProvider1(
        props.data.serviceProviderId,
        payload,
        onResponse,
        onError,
      );
    } else {
      let onResponse = (res) => {
        EventService.emit("showError", {
          message: `Service provider updated`,
        });
        setLoading(false);
        if (showUpdateCityMappingNowDialog) {
          setShowUpdateCityMappingNowDialog(true);
          getServiceProvider(res?.id);
        } else {
          props.resetDashboardServiceProvider();
          onExit();
        }
      };
      let onError = (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
        setSPbodyToUpdate(null);
        setOpenPropCalendarChangesDialog(false);
        setLoading(false);
      };
      if (propagate === 1) {
        setLoading(true);
        createServiceProviderUtil.updateServiceProvider2(
          props.data.serviceProviderId,
          payload,
          onResponse,
          onError,
        );
      } else {
        updateServiceProvider3(payload, showUpdateCityMappingNowDialog);
      }
    }
  };
  const updateServiceProvider3 = (
    payload,
    showUpdateCityMappingNowDialog = false,
  ) => {
    setLoading(true);
    let onResponse = (res) => {
      EventService.emit("showError", {
        message: `Service provider updated`,
      });
      setLoading(false);
      if (showUpdateCityMappingNowDialog) {
        setShowUpdateCityMappingNowDialog(true);
        getServiceProvider(res?.id);
      } else {
        props.resetDashboardServiceProvider();
        onExit();
      }
    };
    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
      setOpenPropCalendarChangesDialog(false);
      setLoading(false);
    };
    createServiceProviderUtil.updateServiceProvider(
      props.data.serviceProviderId,
      payload,
      onResponse,
      onError,
    );
  };

  return (
    <div className="mp-page-padding">
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div className="mp-two-side-view">
            <div className="mp-heading-with-back-button">
              <div
                id="back_button"
                onClick={() => {
                  onExit();
                }}
              >
                <FontIcon
                  style={{
                    fontSize: "36px",
                    paddingTop: "1px",
                    paddingRight: "12px",
                    cursor: "pointer",
                    color: "#ef7c01",
                  }}
                >
                  arrow_back
                </FontIcon>
              </div>
              <h1>
                {mode == 1
                  ? `Create new service provider`
                  : mode == 2
                    ? `View service provider`
                    : mode == 3
                      ? `Update service provider`
                      : ``}
              </h1>
            </div>
            <div className="mp-buttons-container">
              <div className="mp-buttons-right-alignment">
                {mode != 2 && (
                  <Button
                    id="save_provider"
                    raised
                    disabled={loading}
                    className={
                      loading
                        ? "mp-button-save-disabled"
                        : "mp-button-save-enabled"
                    }
                    onClick={() => {
                      verifyData();
                    }}
                  >
                    {mode == 1 ? "Save" : "Update"}
                  </Button>
                )}

                <Button
                  id="cancel_provider"
                  raised
                  disabled={loading}
                  className="mp-button-cancel"
                  onClick={() => {
                    onExit();
                  }}
                >
                  {"Cancel"}
                </Button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <h3 className="mp-sub-heading-margin">{`Service category`}</h3>
      <Row>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="mp-field-container">
            <div className="mp-label">
              {`Service type`}
              <label className="mp-label-red"> *</label>
            </div>
            <div id="service_type_dropdown">
              <SelectField
                id={"mp-select-service-type"}
                disabled={mode == 2 || mode == 3}
                placeholder="Select"
                fullWidth={true}
                className="mp-select-field"
                menuItems={servicesTypeObj}
                value={
                  providerToCreate.serviceTypeId != null
                    ? providerToCreate.serviceTypeId
                    : ""
                }
                onChange={(e) => {
                  let selectedService = servicesTypeArr.find(
                    (ser) => e == ser.id,
                  );

                  if (selectedService.id == 1) {
                    setProviderToCreate({
                      ...providerToCreate,
                      serviceTypeId: e,
                      serviceSubtypeId: selectedService?.providerSubTypeReq
                        ? ""
                        : 0,
                      checkupInfo: null,
                      vaccineInfo: null,
                      consultationInfo: {
                        identityDetails: {},
                        contactDetails: {},
                        address: {},
                        reviewData: {},
                        vendorGroup: {},
                        availability: {
                          config: {
                            slotDurationInMinutes: "",
                            bookingPerSlot: "",
                            minBookingDays: "",
                            maxAdvBookingDays: "",
                          },
                          schedule: {
                            sunday: [],
                            monday: [],
                            tuesday: [],
                            wednesday: [],
                            thursday: [],
                            friday: [],
                            saturday: [],
                          },
                          unavailableTime: [],
                          availableTime: [],
                        },
                      },
                    });
                    setServiceProviderView(1);
                  } else if (selectedService.id == 2) {
                    setProviderToCreate({
                      ...providerToCreate,
                      serviceTypeId: e,
                      serviceSubtypeId: selectedService?.providerSubTypeReq
                        ? ""
                        : 0,
                      consultationInfo: null,
                      vaccineInfo: null,
                      checkupInfo: {
                        identityDetails: {},
                        contactDetails: {},
                        address: {},
                        reviewData: {},
                        vendorGroup: {},
                        availability: {
                          config: {
                            slotDurationInMinutes: "",
                            bookingPerSlot: "",
                            minBookingDays: "",
                            maxAdvBookingDays: "",
                          },
                          schedule: {
                            sunday: [],
                            monday: [],
                            tuesday: [],
                            wednesday: [],
                            thursday: [],
                            friday: [],
                            saturday: [],
                          },
                          unavailableTime: [],
                          availableTime: [],
                        },
                      },
                    });
                    setServiceProviderView(2);
                  } else if (selectedService.id == 3) {
                    setProviderToCreate({
                      ...providerToCreate,
                      serviceTypeId: e,
                      serviceSubtypeId: selectedService?.providerSubTypeReq
                        ? ""
                        : 0,
                      consultationInfo: null,
                      checkupInfo: null,
                      vaccineInfo: {
                        identityDetails: {},
                        contactDetails: {},
                        address: {},
                        reviewData: {},
                        vendorGroup: {},
                        availability: {
                          config: {
                            slotDurationInMinutes: "",
                            bookingPerSlot: "",
                            minBookingDays: "",
                            maxAdvBookingDays: "",
                          },
                          schedule: {
                            sunday: [],
                            monday: [],
                            tuesday: [],
                            wednesday: [],
                            thursday: [],
                            friday: [],
                            saturday: [],
                          },
                          unavailableTime: [],
                          availableTime: [],
                        },
                      },
                    });
                    setServiceProviderView(3);
                  } else if (selectedService.id == 4) {
                    setProviderToCreate({
                      ...providerToCreate,
                      serviceTypeId: e,
                      serviceSubtypeId: selectedService?.providerSubTypeReq
                        ? ""
                        : 0,
                      consultationInfo: null,
                      checkupInfo: null,
                      vaccineInfo: null,
                      dentalInfo: null,
                      gymInfo: {
                        identityDetails: {},
                        contactDetails: {},
                        address: {},
                        reviewData: {},
                        vendorGroup: {},
                        availability: {
                          config: {
                            slotDurationInMinutes: "",
                            bookingPerSlot: "",
                            minBookingDays: "",
                            maxAdvBookingDays: "",
                          },
                          schedule: {
                            sunday: [],
                            monday: [],
                            tuesday: [],
                            wednesday: [],
                            thursday: [],
                            friday: [],
                            saturday: [],
                          },
                          unavailableTime: [],
                          availableTime: [],
                        },
                      },
                    });
                    setServiceProviderView(4);
                  } else if (selectedService.id == 5) {
                    setProviderToCreate({
                      ...providerToCreate,
                      serviceTypeId: e,
                      serviceSubtypeId: selectedService?.providerSubTypeReq
                        ? ""
                        : 0,
                      consultationInfo: null,
                      checkupInfo: null,
                      gymInfo: null,
                      vaccineInfo: null,
                      dentalInfo: {
                        identityDetails: {},
                        contactDetails: {},
                        address: {},
                        reviewData: {},
                        vendorGroup: {},
                        availability: {
                          config: {
                            slotDurationInMinutes: "",
                            bookingPerSlot: "",
                            minBookingDays: "",
                            maxAdvBookingDays: "",
                          },
                          schedule: {
                            sunday: [],
                            monday: [],
                            tuesday: [],
                            wednesday: [],
                            thursday: [],
                            friday: [],
                            saturday: [],
                          },
                          unavailableTime: [],
                          availableTime: [],
                        },
                      },
                    });
                    setServiceProviderView(5);
                  }
                }}
              />
            </div>
          </div>
        </Col>
      </Row>
      {serviceProviderView == 1 && countries != null && (
        <ServiceProviderConsultation
          providerToCreate={providerToCreate}
          setProviderToCreate={setProviderToCreate}
          mode={mode}
          countries={countries}
          calendarHeadings={calendarHeadings}
        />
      )}
      {serviceProviderView == 2 && countries != null && (
        <ServiceProviderHealthCheckup
          providerToCreate={providerToCreate}
          setProviderToCreate={setProviderToCreate}
          mode={mode}
          countries={countries}
          calendarHeadings={calendarHeadings}
        />
      )}
      {serviceProviderView == 3 && countries != null && (
        <ServiceProviderVaccine
          providerToCreate={providerToCreate}
          setProviderToCreate={setProviderToCreate}
          mode={mode}
          countries={countries}
          calendarHeadings={calendarHeadings}
        />
      )}
      {serviceProviderView == 4 && countries != null && (
        <ServiceProviderGym
          providerToCreate={providerToCreate}
          setProviderToCreate={setProviderToCreate}
          mode={mode}
          handleUpdateMode={(newMode) => {
            setMode(newMode);
          }}
          countries={countries}
          calendarHeadings={calendarHeadings}
          verifyData={verifyData}
          initialCityMapping={initialCityMapping}
          enableCityMappingTextRef={enableCityMappingTextRef}
        />
      )}
      {serviceProviderView == 5 && countries != null && (
        <ServiceProviderDentalCheckup
          providerToCreate={providerToCreate}
          setProviderToCreate={setProviderToCreate}
          mode={mode}
          countries={countries}
          calendarHeadings={calendarHeadings}
        />
      )}
      {openPropCalendarChangesDialog && (
        <DialogContainer
          id="mp-calendar-changes-prop-confirm-dialog"
          visible={openPropCalendarChangesDialog}
          focusOnMount={false}
          onHide={() => {
            setOpenPropCalendarChangesDialog(false);
            setSPbodyToUpdate(null);
            setLoading(false);
          }}
          width="500px"
          autosizeContent
          height="auto"
          style={{ textAlign: "left" }}
          dialogStyle={{ borderRadius: "10px", position: "relative" }}
        >
          <div className="mp-confirm-diaglog-1">
            <div>{`Do you want the changes in the calendar to be reflected`}</div>
            <div>{`in the default calendar and customised calendar?`}</div>
            <br />
            <div className="mp-confirm-diaglog-btn">
              <div className="mp-buttons-right-alignment">
                <Button
                  raised
                  disabled={loading}
                  className={"mp-button-save-enabled"}
                  onClick={() => {
                    if (SPbodyToUpdate != null) {
                      updateServiceProvider(SPbodyToUpdate, 1);
                    }
                    setLoading(false);
                  }}
                >
                  {"Yes"}
                </Button>

                <Button
                  raised
                  disabled={loading}
                  className="mp-button-cancel"
                  onClick={() => {
                    if (SPbodyToUpdate != null) {
                      updateServiceProvider(SPbodyToUpdate, 2);
                    }
                  }}
                >
                  {"No"}
                </Button>
              </div>
            </div>
          </div>
        </DialogContainer>
      )}
      {showUpdateCityMappingNowDialog && (
        <DialogContainer
          id="mp-calendar-changes-prop-confirm-dialog"
          visible={showUpdateCityMappingNowDialog}
          focusOnMount={false}
          onHide={() => {
            // setOpenPropCalendarChangesDialog(false);
            // setSPbodyToUpdate(null);
            // setLoading(false);
          }}
          width="500px"
          autosizeContent
          height="auto"
          style={{ textAlign: "left", zIndex: 200 }}
          dialogStyle={{ borderRadius: "10px", position: "relative" }}
        >
          <div className="mp-confirm-diaglog-1">
            <h3>{`Service provider ${
              mode == 1 ? `created` : mode == 3 ? `updated` : ``
            } successfully!`}</h3>
            <br />
            <div>{`Do you want to add/update cities now or later?`}</div>
            <br />
            {/* <div>{`in the default calendar and customised calendar?`}</div> */}
            <br />
            <div className="mp-confirm-diaglog-btn">
              <div className="mp-buttons-right-alignment">
                <Button
                  raised
                  disabled={loading}
                  className={"mp-button-save-enabled"}
                  onClick={() => {
                    // if (SPbodyToUpdate != null) {
                    //   updateServiceProvider(SPbodyToUpdate, 1);
                    // }
                    // scrollToCitySelectionHeading();
                    setLoading(false);
                    setShowUpdateCityMappingNowDialog(false);
                    setMode(3);
                    scrollToCitySelectionHeading();
                  }}
                >
                  {"Now"}
                </Button>

                <Button
                  raised
                  disabled={loading}
                  className="mp-button-cancel"
                  onClick={() => {
                    setLoading(false);
                    setShowUpdateCityMappingNowDialog(false);
                    props.resetDashboardServiceProvider();
                    onExit();
                  }}
                >
                  {"Later"}
                </Button>
              </div>
            </div>
          </div>
        </DialogContainer>
      )}
    </div>
  );
};

export default CreateServiceProvider;
